import { createActions, handleActions } from 'redux-actions'

export const CREATE_ORGANISATION = 'organisations/CREATE_ORGANISATION'
export const CREATE_SUCCESS = 'organisations/CREATE_SUCCESS'
export const CREATE_FAILURE = 'organisations/CREATE_FAILURE'

export const UPDATE_ORGANISATION = 'organisations/UPDATE_ORGANISATION'
export const UPDATE_BILLING_INFO = 'organisations/UPDATE_BILLING_INFO'
export const UPDATE_SUCCESS = 'organisations/UPDATE_SUCCESS'
export const UPDATE_FAILURE = 'organisations/UPDATE_FAILURE'

export const DELETE_ORGANISATION = 'organisations/DELETE_ORGANISATION'
export const DELETE_SUCCESS = 'organisations/DELETE_SUCCESS'
export const DELETE_FAILURE = 'organisations/DELETE_FAILURE'

export const CLAIM_ORGANISATION_REQUEST = 'organisations/CLAIM_ORGANISATION_REQUEST'
export const CLAIM_ORGANISATION_REQUEST_SUCCESS = 'organisations/CLAIM_ORGANISATION_REQUEST_SUCCESS'
export const CLAIM_ORGANISATION_REQUEST_FAILURE = 'organisations/CLAIM_ORGANISATION_REQUEST_FAILURE'

export const CLAIM_ORGANISATION = 'organisations/CLAIM_ORGANISATION'
export const CLAIM_ORGANISATION_SUCCESS = 'organisations/CLAIM_ORGANISATION_SUCCESS'
export const CLAIM_ORGANISATION_FAILURE = 'organisations/CLAIM_ORGANISATION_FAILURE'

export const FETCH_ORGANISATIONS = 'organisations/FETCH_ORGANISATIONS'

export const FETCH_ORG_FOR_PUBLIC_PAGE = 'organisations/FETCH_ORG_FOR_PUBLIC_PAGE'
export const FETCH_SUCCESS = 'organisations/FETCH_SUCCESS'
export const FETCH_PUBLIC_ORGS_SUCCESS = 'organisations/FETCH_PUBLIC_ORGS_SUCCESS'
export const FETCH_FAILURE = 'organisations/FETCH_FAILURE'
export const FETCH_OWN_ORGANISATIONS = 'organisations/FETCH_OWN_ORGANISATIONS'

export const ADD_ORG_ADMIN = 'organisations/ADD_ORG_ADMIN'
export const ADD_ORG_ADMIN_SUCCESS = 'organisations/ADD_ORG_ADMIN_SUCCESS'
export const ADD_ORG_ADMIN_FAILURE = 'organisations/ADD_ORG_ADMIN_FAILURE'

export const UPDATE_ORG_ADMIN = 'organisations/UPDATE_ORG_ADMIN'
export const UPDATE_ORG_ADMIN_SUCCESS = 'organisations/UPDATE_ORG_ADMIN_SUCCESS'
export const UPDATE_ORG_ADMIN_FAILURE = 'organisations/UPDATE_ORG_ADMIN_FAILURE'

export const REMOVE_ORG_ADMIN = 'organisations/REMOVE_ORG_ADMIN'
export const REMOVE_ORG_ADMIN_SUCCESS = 'organisations/REMOVE_ORG_ADMIN_SUCCESS'
export const REMOVE_ORG_ADMIN_FAILURE = 'organisations/REMOVE_ORG_ADMIN_FAILURE'

export const UPDATE_ORG_STORIES = 'organisations/UPDATE_ORG_STORIES'

export const FETCH_ORGANISATION = 'organisations/FETCH_ORGANISATION'
export const SINGLE_FETCH_SUCCESS = 'organisations/SINGLE_FETCH_SUCCESS'
export const SINGLE_FETCH_FAILURE = 'organisations/SINGLE_FETCH_FAILURE'

export const FETCH_LEARNERS = 'organisations/FETCH_LEARNERS'
export const FETCH_LEARNERS_SUCCESS = 'organisations/FETCH_LEARNERS_SUCCESS'
export const FETCH_LEARNERS_FAILURE = 'organisations/FETCH_LEARNERS_FAILURE'

export const LOGOUT_SUCCESS = 'authentication/LOGOUT_SUCCESS'

export const {
  organisations: {
    createOrganisation,
    createSuccess,
    createFailure,

    updateOrganisation,
    updateBillingInfo,
    updateSuccess,
    updateFailure,

    deleteOrganisation,
    deleteSuccess,
    deleteFailure,

    claimOrganisation,
    claimOrganisationSuccess,
    claimOrganisationFailure,

    claimOrganisationRequest,
    claimOrganisationRequestSuccess,
    claimOrganisationRequestFailure,

    fetchOrganisations,
    fetchOwnOrganisations,
    fetchSuccess,
    fetchPublicOrgsSuccess,
    fetchFailure,

    addOrgAdmin,
    addOrgAdminSuccess,
    addOrgAdminFailure,

    updateOrgAdmin,
    updateOrgAdminSuccess,
    updateOrgAdminFailure,

    removeOrgAdmin,
    removeOrgAdminSuccess,
    removeOrgAdminFailure,

    updateOrgStories,

    fetchOrganisation,
    fetchOrgForPublicPage,
    singleFetchSuccess,
    singleFetchFailure,

    fetchLearners,
    fetchLearnersSuccess,
    fetchLearnersFailure
  }
} = createActions({
  [CREATE_ORGANISATION]: undefined,
  [CREATE_SUCCESS]: undefined,
  [CREATE_FAILURE]: undefined,

  [UPDATE_ORGANISATION]: undefined,
  [UPDATE_BILLING_INFO]: undefined,
  [UPDATE_SUCCESS]: undefined,
  [UPDATE_FAILURE]: undefined,

  [DELETE_ORGANISATION]: undefined,
  [DELETE_SUCCESS]: organisationId => ({ organisationId }),
  [DELETE_FAILURE]: undefined,

  [CLAIM_ORGANISATION]: undefined,
  [CLAIM_ORGANISATION_SUCCESS]: undefined,
  [CLAIM_ORGANISATION_FAILURE]: undefined,

  [CLAIM_ORGANISATION_REQUEST]: undefined,
  [CLAIM_ORGANISATION_REQUEST_SUCCESS]: undefined,
  [CLAIM_ORGANISATION_REQUEST_FAILURE]: undefined,

  [FETCH_ORGANISATIONS]: undefined,
  [FETCH_OWN_ORGANISATIONS]: undefined,

  [FETCH_SUCCESS]: undefined,
  [FETCH_PUBLIC_ORGS_SUCCESS]: undefined,
  [FETCH_FAILURE]: undefined,

  [ADD_ORG_ADMIN]: undefined,
  [ADD_ORG_ADMIN_SUCCESS]: undefined,
  [ADD_ORG_ADMIN_FAILURE]: undefined,

  [UPDATE_ORG_ADMIN]: undefined,
  [UPDATE_ORG_ADMIN_SUCCESS]: undefined,
  [UPDATE_ORG_ADMIN_FAILURE]: undefined,

  [REMOVE_ORG_ADMIN]: undefined,
  [REMOVE_ORG_ADMIN_SUCCESS]: undefined,
  [REMOVE_ORG_ADMIN_FAILURE]: undefined,

  [UPDATE_ORG_STORIES]: undefined,
  [FETCH_ORG_FOR_PUBLIC_PAGE]: undefined,
  [FETCH_ORGANISATION]: undefined,
  [SINGLE_FETCH_SUCCESS]: undefined,
  [SINGLE_FETCH_FAILURE]: undefined,

  [FETCH_LEARNERS]: undefined,
  [FETCH_LEARNERS_FAILURE]: undefined,
  [FETCH_LEARNERS_SUCCESS]: undefined
})

const initialState = {
  isLoading: false,
  isLoadingViaOrgId: false,
  isSubmitting: false,
  loadWasSuccess: false,
  hasError: false,
  hasSingleOrgError: false,
  errorMessage: null,
  data: [],
  learnersData: {},
  pageCount: 1,
  orgTypes: [],
  customFields: [],
  singleOrganisationData: {},
  organisationId: null,
  errorType: null
}

export default handleActions(
  {
    [CREATE_ORGANISATION]: (state, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
      isSubmitting: true
    }),
    [CREATE_SUCCESS]: (state, { payload = {} }) => {
      return {
        ...state,
        singleOrganisationData: payload,
        isLoading: false,
        isSubmitting: false,
        data: [payload, ...state.data.filter(o => o.id !== payload.id)]
      }
    },
    [CREATE_FAILURE]: (state, { payload }) => ({
      ...state,
      hasError: true,
      errorMessage: payload,
      isLoading: false,
      isSubmitting: false
    }),
    [UPDATE_ORGANISATION]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [UPDATE_BILLING_INFO]: state => ({ ...state, isLoading: false, isSubmitting: true }),
    [UPDATE_SUCCESS]: (state, { payload }) => {
      const updatedData = [payload, ...state.data.filter(o => o.id !== payload.id)]

      return {
        ...state,
        isLoading: false,
        isSubmitting: false,
        singleOrganisationData: payload,
        data: updatedData
      }
    },
    [UPDATE_FAILURE]: state => ({ ...state, isLoading: false, isSubmitting: false }),
    [DELETE_ORGANISATION]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      opportunityId: payload
    }),
    [DELETE_SUCCESS]: (state, { payload }) => {
      return {
        ...state,
        isLoading: false,
        data: state.data.filter(o => o.id !== payload.organisationId),
        opportunityId: null
      }
    },
    [DELETE_FAILURE]: state => ({ ...state, isLoading: false, opportunityId: null }),

    [CLAIM_ORGANISATION]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      organistionId: payload,
      submissionWasSuccess: null
    }),
    [CLAIM_ORGANISATION_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        submissionWasSuccess: true
      }
    },
    [CLAIM_ORGANISATION_FAILURE]: state => ({
      ...state,
      isLoading: false,
      submissionWasSuccess: false,
      hasError: true
    }),

    [CLAIM_ORGANISATION_REQUEST]: (state, { payload }) => ({
      ...state,
      isLoading: true,
      organistionId: payload,
      submissionWasSuccess: null
    }),
    [CLAIM_ORGANISATION_REQUEST_SUCCESS]: state => {
      return {
        ...state,
        isLoading: false,
        submissionWasSuccess: true
      }
    },
    [CLAIM_ORGANISATION_REQUEST_FAILURE]: state => ({
      ...state,
      isLoading: false,
      submissionWasSuccess: false,
      hasError: true
    }),

    [FETCH_ORGANISATIONS]: state => ({
      ...state,
      errorMessage: false,
      errorType: null,
      hasError: false,
      hasSingleOrgError: false,
      isLoading: true,
      isSubmitting: false,
      loadWasSuccess: null
    }),
    [FETCH_OWN_ORGANISATIONS]: state => ({
      ...state,
      errorMessage: false,
      errorType: null,
      hasError: false,
      hasSingleOrgError: false,
      isLoading: true,
      isSubmitting: false,
      loadWasSuccess: null
    }),

    [FETCH_PUBLIC_ORGS_SUCCESS]: (state, { payload }) => {
      const { orgData, orgTypes } = payload

      return {
        ...state,
        data: orgData,
        orgTypes,
        isLoading: false,
        hasError: false
      }
    },
    [FETCH_SUCCESS]: (state, { payload }) => {
      const { orgData, orgTypes, customFields, pageCount } = payload

      return {
        ...state,
        data: orgData,
        pageCount,
        orgTypes,
        customFields,
        isLoading: false,
        hasError: false,
        loadWasSuccess: true
      }
    },
    [FETCH_FAILURE]: (state, payload) => ({
      ...state,
      ...payload,
      isLoading: false,
      loadWasSuccess: false
    }),
    [FETCH_ORG_FOR_PUBLIC_PAGE]: state => ({
      ...state,
      hasError: false,
      isLoading: true,
      isLoadingViaOrgId: true
    }),
    [FETCH_ORGANISATION]: state => {
      return { ...state, isLoading: true, hasSingleOrgError: false, hasError: false }
    },
    [SINGLE_FETCH_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      isLoadingViaOrgId: false,
      hasSubmitted: false,
      singleOrganisationData: payload,
      organisationId: payload.id,
      hasSingleOrgError: false,
      loadWasSuccess: true,
      hasError: false
    }),
    [SINGLE_FETCH_FAILURE]: (state, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
      isLoadingViaOrgId: false,
      hasSingleOrgError: true,
      loadWasSuccess: false,
      hasError: true
    }),
    [FETCH_LEARNERS]: state => {
      return { ...state, isLoading: true }
    },
    [FETCH_LEARNERS_SUCCESS]: (state, { payload }) => ({
      ...state,
      isLoading: false,
      learnersData: payload.learners || {},
      loadWasSuccess: true,
      hasError: false
    }),
    [FETCH_LEARNERS_FAILURE]: (state, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
      isLoadingViaOrgId: false,
      loadWasSuccess: false,
      hasError: true
    }),

    [UPDATE_ORG_STORIES]: (state, { payload }) => {
      const { singleOrganisationData } = state
      const stories = singleOrganisationData.stories || []
      if (!stories.length) return state

      const newOrgData = {
        ...singleOrganisationData,
        stories: stories.map(s => {
          if (s.id === payload.id) {
            const oneMore = (s.story_likes || 0) + 1
            const oneLess = (s.story_likes || 1) - 1
            const userLikesStory = payload.value === 'liked'
            const newLikesCount = userLikesStory ? oneMore : oneLess

            return { ...s, story_likes: newLikesCount, user_likes_story: userLikesStory }
          }

          return s
        })
      }

      return { ...state, singleOrganisationData: newOrgData }
    },

    [ADD_ORG_ADMIN]: state => ({ ...state, isLoading: true, hasSubmitted: true }),
    [ADD_ORG_ADMIN_SUCCESS]: (state, { payload }) => {
      const updatedSingleOrganisationData = {
        ...state.singleOrganisationData,
        admins: [
          ...state.singleOrganisationData.admins,
          {
            avatar_url: payload.data.avatar_url,
            email: payload.member_email,
            f_name: payload.member_f_name,
            id: payload.data.id,
            l_name: payload.member_l_name,
            mobile: payload.member_mobile,
            role: payload.member_role,
            status: payload.data.status
          }
        ]
      }

      return {
        ...state,
        isLoading: false,
        hasSubmitted: true,
        hasError: false,
        singleOrganisationData: updatedSingleOrganisationData
      }
    },
    [ADD_ORG_ADMIN_FAILURE]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      hasError: true
    }),

    [UPDATE_ORG_ADMIN]: state => ({ ...state, isLoading: true, hasSubmitted: true }),
    [UPDATE_ORG_ADMIN_SUCCESS]: (state, { payload }) => {
      const deletedAdminId = parseInt(payload.adminId)
      const updatedAdmins = state.singleOrganisationData.admins.filter(a => a.id !== deletedAdminId)
      const updatedSingleOrganisationData = {
        ...state.singleOrganisationData,
        admins: updatedAdmins
      }

      return {
        ...state,
        isLoading: false,
        hasSubmitted: true,
        hasError: false,
        singleOrganisationData: updatedSingleOrganisationData
      }
    },
    [UPDATE_ORG_ADMIN_FAILURE]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      hasError: true
    }),

    [REMOVE_ORG_ADMIN]: state => ({ ...state, isLoading: true, hasSubmitted: true }),
    [REMOVE_ORG_ADMIN_SUCCESS]: (state, { payload }) => {
      const deletedAdminId = parseInt(payload.recordId)
      const updatedAdmins = state.singleOrganisationData.admins.filter(a => a.id !== deletedAdminId)
      const updatedSingleOrganisationData = {
        ...state.singleOrganisationData,
        admins: updatedAdmins
      }

      return {
        ...state,
        isLoading: false,
        hasSubmitted: true,
        hasError: false,
        singleOrganisationData: updatedSingleOrganisationData
      }
    },
    [REMOVE_ORG_ADMIN_FAILURE]: state => ({
      ...state,
      isLoading: false,
      hasSubmitted: true,
      hasError: true
    })
  },
  initialState
)
